import { render, staticRenderFns } from "./BuildingBulkCreate.vue?vue&type=template&id=5a4c213a"
import script from "./BuildingBulkCreate.vue?vue&type=script&lang=ts"
export * from "./BuildingBulkCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports